module.exports = __webpack_public_path__ + "files/ccb62440149af353f57802b2da300273.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/generic.png
// module id = 417
// module chunks = 76